<script setup lang="ts" name="DefaultLayout">
import { MicroAppFooter } from '@mp/component'
import Header from './components/Header.vue'
import SideMenu from './components/SideMenu.vue'
import { computed, provide } from 'vue'
import { constantRoutes } from '@/router'
import { useRoute } from 'vue-router'

// *找到当前路由信息
const route = useRoute()
const parentRoute = computed(() => constantRoutes.filter(i => i.path !== '/').find(i => route.path.startsWith(i.path)))
const curRoutes = computed(() => parentRoute.value?.children)

const visibleBreadcrumb = computed(() => {
  const hideRoutes = ['NoPermission', 'DashboardIndex']
  if (hideRoutes.includes(route.name as string))
    return false
  return true
})

// 提供当前路由信息给子组件
provide('currentRoutes', curRoutes)
</script>

<template>
  <Header />

  <div class="content-container flex items-start relative">
    <div v-if="curRoutes && curRoutes?.length > 1" class="w-[200px] mr-4 sticky top-[calc(64px)] pt-6">
      <SideMenu />
    </div>
    <div class="flex-1 w-1 relative pt-6" style="--el-text-color-regular: var(--n-800); --el-text-color-primary: var(--n-400)">
      <el-breadcrumb v-if="visibleBreadcrumb" separator="/" class="mb-5">
        <el-breadcrumb-item :to="{ name: parentRoute?.name }">
          {{ parentRoute?.meta?.title }}
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ route.meta?.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <RouterView />
      <MicroAppFooter />
    </div>
  </div>
</template>
